// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p {\n  padding: 10px;\n  margin: 10px 0;\n}", "",{"version":3,"sources":["webpack://./src/app/pages/consentimiento-datos/consentimiento-datos.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,cAAA;AACD","sourcesContent":["p {\r\n\tpadding: 10px;\r\n\tmargin: 10px 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
